const enums = {
    filters: [
        'Autopay_Enabled_Tenants',
        'Saved_Cards_With_Balance_Due',
        'Saved_Accounts_With_Balance_Due',
    ],
};

export default enums;
